import { type ReactElement } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { lazyWithReload } from './lazyWithReload';

// ============================================================================
// characterRoutes (R2-07, Diagnose D3 (c)) — die Charakter-Flaeche nach dem
// Aufloesen der alten Eltern-Route.
// ----------------------------------------------------------------------------
// Bis R2-07 hing ALLES unter der Split-Route `/characters`: Liste (Eltern),
// Editor (`new`, `:id/edit`) und Detail (`:id`) als Kinder. Damit mountete bei
// jedem „Bearbeiten" die alte Uebersicht MIT — im compact-Fall bleiben beide
// Panes montiert (SplitView versteckt nur per visibility) → genau das
// „Aufblitzen der alten Liste", das Julius gemeldet hat.
//
// Jetzt gilt (Entscheidung 3 des Pakets):
//   /characters            → harter Redirect auf /chats (Navigate replace)
//   /characters/manage     → die alte Liste als schlanke VERWALTUNG (ohne Split,
//                            also ohne dauerhaft leeren Detail-Pane)
//   /characters/new        → Editor, EIGENSTAENDIG (keine Liste daneben)
//   /characters/:id        → Detail, EIGENSTAENDIG
//   /characters/:id/edit   → Editor mit `key` in der ROUTE, EIGENSTAENDIG
//
// Die PFADE der drei Arbeitsrouten bleiben unveraendert — Abizeitungs-QR-,
// Push- und Onboarding-Deep-Links (`/characters/new?mode=companion`) sowie die
// Legacy-Link-Aufloesung in formatAiMessage.tsx tragen weiter.
//
// `/characters/manage` schlaegt `/characters/:id` im react-router-Ranking
// (statisches Segment vor dynamischem) — die Reihenfolge in dieser Liste ist
// dafuer NICHT massgeblich, aber bewusst trotzdem so sortiert.
//
// Als exportierte Tabelle (Muster worldRedirects.tsx), damit routes.tsx UND der
// Vertragstest characterRoutes.test.tsx dieselbe Quelle lesen.
// ============================================================================

const CharactersManagePage = lazyWithReload(() => import('../pages/characters'));
const CharacterEditorPage = lazyWithReload(() => import('../pages/character-editor'));
const CharacterDetailPane = lazyWithReload(() => import('../pages/characters/CharacterDetailPane'));
const CharacterEditorRoute = lazyWithReload(() => import('../pages/character-editor/CharacterEditorRoute'));

export const characterAreaRoutes: ReactElement[] = [
  <Route key="chars-index" path="/characters" element={<Navigate to="/chats" replace />} />,
  <Route key="chars-manage" path="/characters/manage" element={<CharactersManagePage />} />,
  <Route key="chars-new" path="/characters/new" element={<CharacterEditorPage key="new" />} />,
  <Route key="chars-detail" path="/characters/:id" element={<CharacterDetailPane />} />,
  <Route key="chars-edit" path="/characters/:id/edit" element={<CharacterEditorRoute />} />,
];
